import type { InferType } from 'yup'
import { object, string } from 'yup'

export const contactSchema = object({
  name: string().required().label('Name'),
  from: string().email().min(3).required().label('Email'),
  subject: string().required().label('Subject'),
  text: string().required().label('Message'),
})

export type ContactSchemaType = InferType<typeof contactSchema>
